import { FunctionComponent } from 'preact';
import cn from 'classnames';

import { useDoubleTap } from '../../hooks/useDoubleTap';

interface TouchPanelProps {
  align: 'left' | 'right';
  collapsed?: boolean;
  onTap: (e: MouseEvent) => void;
  onDoubleTap: () => void;
}

export const TouchPanel: FunctionComponent<TouchPanelProps> = ({
  align,
  collapsed,
  onTap,
  onDoubleTap,
}) => {
  const { handleClick } = useDoubleTap({
    onTap,
    onDoubleTap,
  });

  return (
    <div
      className={cn('vgp-touch-panel', `vgp-touch-panel-${align}`, {
        'vgp-touch-panel-collapsed': collapsed,
      })}
      onClick={handleClick}
    />
  );
};
